import React from 'react';
import {initialState, LayoutDispatcher, LayoutPayload, LayoutReducer} from './LayoutProviderReducer';

const LayoutStateContext = React.createContext<LayoutPayload>({});
const LayoutDispatchContext = React.createContext<React.Dispatch<LayoutDispatcher>>(() => null );

export function useLayoutState() {
    const context = React.useContext(LayoutStateContext);
    if (context === undefined) {
        throw new Error('useLayoutState must be used within a LayoutProvider');
    }
    return context;
}

export function useLayoutDispatch() {
    const context = React.useContext(LayoutDispatchContext);
    if (context === undefined) {
        throw new Error('useLayoutDispatch must be used within a LayoutProvider');
    }

    return context;
}

interface ViewProps {
    children?: React.ReactNode | undefined
}

export const LayoutProvider: React.FunctionComponent<ViewProps> = (props) => {
    const [layout, dispatch] = React.useReducer(LayoutReducer, initialState);

    return (
        <LayoutStateContext.Provider value={layout}>
            <LayoutDispatchContext.Provider value={dispatch}>
                { props.children }
            </LayoutDispatchContext.Provider>
        </LayoutStateContext.Provider>
    );
};
